import React from 'react';
import logo from '../gym.jpg'
import './Header.css'

const Header = () => {
   return (
     <div>
       <section className="m-5">
         <nav className="navbar navbar-expand-lg">
           <div className="container-fluid">
             <img src={logo} alt="" />
             <h2 className="logo">Ladies-Gym-Center</h2>
             <button
               className="navbar-toggler"
               type="button"
               data-bs-toggle="collapse"
               data-bs-target="#navbarNav"
               aria-controls="navbarNav"
               aria-expanded="false"
               aria-label="Toggle navigation"
             >
               <span className="navbar-toggler-icon"></span>
             </button>
             <div className="collapse navbar-collapse" id="navbarNav">
               <ul className="navbar-nav ms-auto fs-5">
                 <li className="nav-item">
                   <a className="nav-link" aria-current="page" href="#">
                     Home
                   </a>
                 </li>
                 <li className="nav-item">
                   <a className="nav-link" href="#">
                     Blog
                   </a>
                 </li>
                 <li className="nav-item">
                   <a className="nav-link" href="#">
                     About us
                   </a>
                 </li>
                 <li className="nav-item">
                   <a className="nav-link">Contact us</a>
                 </li>
               </ul>
             </div>
           </div>
         </nav>
       </section>
       {/* <nav className='nav-container'>
         <div className='logo'>
           <img src={logo} alt="" />
           <h1>Ladies-Gym-Center</h1>
         </div>
         <div className='link-container'>
           <ul>
             <li>
               <a href="">Home</a>
             </li>
             <li>
               <a href="">Contact us</a>
             </li>
             <li>
               <a href="">Blog</a>
             </li>
           </ul>
         </div>
       </nav> */}
     </div>
   );
};

export default Header;